/*
 * @Descripttion: 转运-货物预报-批次管理
 * @version:
 * @Author:
 * @Date:
 */
import { Component, Vue, Watch } from 'vue-property-decorator';
import { enumData, userPrefPageSize } from '@/decorators';
import { namespace } from 'vuex-class';
import {Moment} from 'moment';
import { yesNoStatus } from '@/enum';
import {loading} from '@/decorators';
const User = namespace('user');

@Component
export default class ListMixins extends Vue {
  @User.State('customerInfo') protected customerInfo!: TypeHome.CustomerInfoData;
  /** 批次状态枚举 */
  @enumData('Toms/ShippingMark/ShippingMarkStatusEnum')
  protected shippingMarkStatusEnum: TypeBase.EnumListItem[] = [];
  /** 批次状态枚举 */
  @enumData('Toms/ShippingMark/SearchCodeTypeEnum')
  protected searchCodeTypeEnum: TypeBase.EnumListItem[] = [];
  /** 查询条件时间段 */
  protected datetimeDefaultValue: Moment[] = this.$util.getDefaultTimeCondition(this.$enum.common.TimePeriodEnum.THREE_MONTH);
  /** 加载状态 */
  protected loadingStatus = false;
  /** 查询参数(用于导出) */
  protected searchParams: TypeTransportOrderLabelManage.SearchData = this.initSearchData();
  /** 数据总数 */
  protected total = 0;
  /** 批量查询文档值 */
  protected docValue = '';
  /** 表头定义 */
  protected columns: TypeBase.TableColumn[] = [];
  /** 选中的列表 */
  protected selectedList: string[] = [];
  /** 查询条件 */
  protected searchData = this.initSearchData();
  /** 仓库列表 */
  protected warehouseList: TypeTransportOrderCommon.WarehouseItem[] = [];
  /** 物流产品列表 */
  protected logisticsList: TypeTransportOrderCommon.LogisticsItem[] = [];
  /** 列表数据 */
  protected listData: TypeTransportOrderLabelManage.ListItem[] = [];
  /** 是否枚举 */
  protected yesNoStatus: TypeBase.EnumListItem[] = yesNoStatus;
  /** 表格选项配置 */
  protected rowSelection: TypeBase.RowSelection = {};
  /** 初始化查询条件 */
  @userPrefPageSize('transportOrderLabelList')
  protected initSearchData(): TypeTransportOrderLabelManage.SearchData  {
    this.datetimeDefaultValue = [];
    return {
      /** 查询类型  */
      code_type: this.$enum.transportOrder.LabelManageSearchCodeTypeEnum.SHIPPING_MARK_NUMBER,
      /** 查询值  */
      code_value: [],
      /** 时间范围  */
      date_arr: [],
      /** 箱唛状态  */
      box_status: this.$enum.common.StatusEnum.ALL,
      page_index: 1,
      page_size: 20,
    };
  }
  /**
   * @description: 获取列表
   * @param {TypeTransportOrderData} param 参数
   * @return {*}
   */  
  @loading('loadingStatus')
  protected async queryList(param: TypeTransportOrderLabelManage.SearchData): Promise<void> {
    this.rowSelection.selectedRowKeys = this.selectedList = [];
    const searchData = this.$util.deepCopy(param);
    if (searchData.box_status === this.$enum.common.StatusEnum.ALL) {
      searchData.box_status = undefined;
    }
    this.searchParams = this.$util.deepCopy(searchData);
    const { data } = await this.$api.transportOrder.queryShippingMarkList(searchData);
    this.listData = data.list;
    this.total = data.total;
  }
  /**
   * @description: 导出列表数据
   * @param {TypeTransportOrderLabelManage} param 参数
   * @return {*}
   */  
  protected async export(param: TypeTransportOrderLabelManage.SearchData) {
    const { data } = await this.$api.transportOrder.exportShippingMarkList(param);
    this.$util.exportExcel(data);
  }
  /**
   * @description: 获取列表数据
   * @return {*}
   */  
  protected getList() {
    this.queryList(this.searchData);
  }
  protected initColumns() {
    this.columns = [
      {
        title: this.t('箱唛号'),
        name: 'shipping_mark_number',
        filterEmpty: true,
        scopedSlots: { customRender: 'shipping_mark_number' },
        isCopy: true,
      },
      {
        title: this.t('箱唛参考号'),
        name: 'reference_box_number',
        dataIndex: 'reference_box_number',
        width: 130,
        filterEmpty: true,
        isCopy: true,
      },
      {
        title: this.t('预报仓库'),
        name: 'forcast_warehouse_code',
        width: 200,
        scopedSlots: { customRender: 'forcast_warehouse_code' },
        filterEmpty: true,
      },
      {
        title: this.t('签收仓库'),
        name: 'signin_warehouse_code',
        scopedSlots: { customRender: 'signin_warehouse_code' },
        filterEmpty: true,
      },
      {
        title: this.t('箱唛状态'),
        name: 'status_text',
        dataIndex: 'status_text',
        scopedSlots: { customRender: 'status_text' },
      },
      {
        title: this.t('备注'),
        name: 'remark',
        dataIndex: 'remark',
        filterEmpty: true,
      },
      {
        title: this.t('时间'),
        name: 'time',
        dataIndex: 'time',
        key: 'time',
        scopedSlots: { customRender: 'time' },
        width: 220,
      },
      {
        title: this.t('操作'),
        name: 'operation',
        key: 'operation',
        scopedSlots: { customRender: 'operation' },
        width: 100,
        fixed: 'right',
      },
    ];
  }
}
